// extracted by mini-css-extract-plugin
export var name = "styles-module__name___HCSJj";